import React, { useMemo } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Loading } from 'tdesign-react';
import { useSearchParams } from 'react-router-dom';
import { isEmpty, uniqBy } from 'lodash';
import { setCmpVariables, setIpVariables } from '@/slices/execFlowSlice';
import Variables from '@/pages/Maintenance/Executive/components/Variables';
import Steps from '../Steps';
import SummaryList from './SummaryList';

function ConfigVariables({
  loading,
  cmpVariables,
  setCmpVariables,
  ipVariables,
  setIpVariables,
  hostsList,
}) {
  const [searchParams] = useSearchParams();
  const scopeType = Number(searchParams.get('flowType'));

  const hosts = useMemo(() => {
    if (isEmpty(hostsList)) {
      return [];
    } else {
      let temp = [];
      hostsList.forEach((item) => {
        temp = [...temp, ...item.hosts];
      });
      return uniqBy(temp, 'id');
    }
  }, [hostsList]);

  return (
    <Loading loading={loading}>
      <Root>
        <Steps />
        <Vl />
        <Variables
          scopeType={scopeType}
          cmpVariables={cmpVariables}
          setCmpVariables={setCmpVariables}
          ipVariables={ipVariables}
          setIpVariables={setIpVariables}
          hosts={hosts}
          descTitle='包含该变量节点'
        />
        <Vl />
        <SummaryList />
      </Root>
    </Loading>
  );
}

export default connect(
  (state) => ({
    loading: state.execFlow.loading,
    cmpVariables: state.execFlow.cmpVariables,
    hostsList: state.execFlow.hostsList,
    ipVariables: state.execFlow.ipVariables,
  }),
  {
    setCmpVariables,
    setIpVariables,
  },
)(ConfigVariables);

const Root = styled.div`
  display: flex;
`;

const Vl = styled.div`
  background: #e7e7e7;
  width: 1px;
`;
